import _ from 'lodash'

import { XlsxValidationByRow, XlsxValidationByWoksheet, XlsxValidationErrors } from './types'

/**
 * Group a flat list of errors by row (with “general” bucket), and sort:
 *  - “general” first
 *  - numeric rows ascending
 */
const groupByRow = (errors?: XlsxValidationErrors): XlsxValidationByRow[] =>
  _(errors)
    .groupBy((err) => (err.row == null ? '_general' : String(err.row)))
    .toPairs()
    .map<[string, XlsxValidationErrors]>(([rowKey, errs]) => [rowKey, errs])
    .map<XlsxValidationByRow>(([rowKey, errs]) => ({
      row: rowKey === '_general' ? '_general' : Number(rowKey),
      errors: errs,
    }))
    .sortBy((group) => (group.row === '_general' ? -Infinity : (group.row as number)))
    .value()

/**
 * Group the full error list by worksheet name,
 * each containing its RowGroups.
 */
export const groupByWorksheet = (errors?: XlsxValidationErrors): XlsxValidationByWoksheet[] => {
  const bySheet = _.groupBy(errors, 'worksheet') // → Record<string, XxxxValidationError[]>

  return Object.entries(bySheet).map(([worksheet, errs]) => ({
    worksheet,
    rows: groupByRow(errs),
  }))
}
